import type {ContentBlocksFragment} from '@/modules/foundation/sanity/content-blocks/query';
import {PORTABLE_TEXT_FRAGMENT} from '@/modules/foundation/sanity/portable-text/query';

import type {BLOCK_TYPE_BANNER} from './constants';

export const BANNER_FRAGMENT = `//groq
	...,
	description[]{
		${PORTABLE_TEXT_FRAGMENT}
	}
`;

export type BannerFragment = Extract<
	ContentBlocksFragment[number],
	{_type: typeof BLOCK_TYPE_BANNER}
>;
